export default __webpack_public_path__ + "static/971-7b4d94a925b528c52177f1a3a78657c8.gif";